import 'micromodal';

const defaultOptions = {
  awaitCloseAnimation: true,
  awaitOpenAnimation: true,
  disableScroll: true,
  disableFocus: true,
};

const initModal = () => {
  return MicroModal.init(defaultOptions);
};

export default initModal;
